var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getBanners.length)?_c('section',{staticClass:"category-information"},_vm._l((_vm.getBanners),function(banner,index){return _c('div',{key:index},[_c('div',{domProps:{"innerHTML":_vm._s(banner.caption)}})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }